import { StyledComponentProps } from '../../Types'
import { TextareaProps } from '../Textarea/props'
import { StyledInput } from './styles'

export const defaultTypes = [
    'email',
    'number',
    'password',
    'text',
    'date',
    'file',
    'tel',
    'month',
    'week',
    'range',
    'search',
    'time',
    'submit',
    'url',
    'image',
    'color',
    'datetime-local',
    'hidden',
    'reset',
] as const
export type DefaultTypes = (typeof defaultTypes)[number]
export const checkedTypes = ['checkbox', 'radio', 'switch'] as const
export type CheckedTypes = (typeof checkedTypes)[number]

export type StyledInputProps = StyledComponentProps<typeof StyledInput> & {
    type?: DefaultTypes | CheckedTypes
}

export type InputProps =
    | StyledInputProps
    | (TextareaProps & {
          type: 'textarea'
      })
